import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {Bar, BarChart, ResponsiveContainer, XAxis, YAxis} from 'recharts';


export interface FlatStatsGraphProps {
    data?: {[key: string]: number;} | null;
}

export const FlatStatsGraph: FunctionComponent<FlatStatsGraphProps> = observer(({data}) => {
    const graphData: object[] = [];
    if (data) {
        Object.keys(data).forEach(k => {
            graphData.push({
                name: k + ':00', v: data[k],
            });
        });
    }

    if (graphData.length === 0) {
        return <div>No stats data yet!</div>;
    }

    return <div>
        <ResponsiveContainer width="100%" aspect={5}>
            <BarChart data={graphData}>
                <XAxis dataKey="name"/>
                <YAxis/>
                <Bar dataKey="v" fill="#FFFFFF"/>
            </BarChart>
        </ResponsiveContainer>
    </div>;
});
